export default __webpack_public_path__ + "static/media/hollow-right.adcba9da.svg";